import type {Component} from 'grapesjs';
import type {ComponentType} from 'react';

export interface RightPanelSectorProps {
  component: Component;
  hideSectionHeading?: boolean;
}

export type RightPanelSectorTitle = string | ((component: Component) => string);

export interface RightPanelSectorEntry {
  title: RightPanelSectorTitle;
  controls: readonly ComponentType<RightPanelSectorProps>[];
}

const SECTORS: Record<string, RightPanelSectorEntry> = {};

export function registerRightPanelSector(componentType: string, entry: RightPanelSectorEntry): void {
  SECTORS[componentType] = entry;
}

export function getRightPanelSector(componentType: string): RightPanelSectorEntry | undefined {
  return SECTORS[componentType];
}

export function resolveSectorTitle(entry: RightPanelSectorEntry, component: Component): string {
  return typeof entry.title === 'function' ? entry.title(component) : entry.title;
}
